import React from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

export const SegmentControl = ({
  options,
  value,
  onChange,
  size = "medium",
  ...props
}) => {
  const theme = useTheme();

  const getSizeStyles = (size) => {
    switch (size) {
      case "small":
        return { padding: theme.spacing(0.5, 1), fontSize: "0.875rem" };
      case "medium":
        return { padding: theme.spacing(0.75, 1.5), fontSize: "1rem" };
      case "large":
        return { padding: theme.spacing(1, 2), fontSize: "1.125rem" };
      default:
        return { padding: theme.spacing(0.75, 1.5), fontSize: "1rem" };
    }
  };

  const sizeStyles = getSizeStyles(size);

  return (
    <Box
      sx={{
        display: "inline-flex",
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.spacing(1),
        padding: theme.spacing(0.25),
        gap: theme.spacing(0.25),
      }}
      {...props}
    >
      {options.map((option) => {
        const isSelected = value === option.value;
        
        return (
          <Button
            key={option.value}
            onClick={() => onChange(option.value)}
            variant="text"
            sx={{
              ...sizeStyles,
              minWidth: "auto",
              textTransform: "none",
              fontWeight: 500,
              borderRadius: theme.spacing(0.75),
              backgroundColor: isSelected 
                ? theme.palette.common.black 
                : "transparent",
              color: isSelected
                ? theme.palette.common.white
                : theme.palette.text.secondary,
              boxShadow: isSelected 
                ? "0 1px 3px rgba(0, 0, 0, 0.1)" 
                : "none",
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                backgroundColor: isSelected 
                  ? theme.palette.common.black 
                  : theme.palette.grey[50],
                boxShadow: isSelected 
                  ? "0 1px 3px rgba(0, 0, 0, 0.1)" 
                  : "none",
              },
            }}
          >
            {option.label}
          </Button>
        );
      })}
    </Box>
  );
};

SegmentControl.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};